<template>
  <el-select ref="departament" v-model="selected" v-loading="loading" clearable placeholder="Selecione  uma opção"
    @change="update()" @clear="clear()">
    <el-option v-for="row of departments" :key="row.id" :label="row.name" :value="row.id"></el-option>
  </el-select>
</template>

<script>
import { DepartmentService } from "@/services/department/department.services";
export default {
  name: "DepartmentChat",
  props: ["current"],
  data: function () {
    return {
      departments: [],
      selected: "",
      loading: false,
    };
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetch();
    },
    current: function (v) {
      const vm = this;
      console.log('v', v);
      setTimeout(() => {
        vm.selected = vm.$props.current;
      }, 200)
    },
  },
  methods: {
    clear() {
      const vm = this;
      vm.$emit("clear");
    },
    get(department) {
      return this.departments.find(x => x.id === department);
    },
    fetch() {
      const vm = this;
      vm.loading = true;
      DepartmentService.chats()
        .then((response) => {
          vm.departments = response;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
};
</script>